module.exports = __webpack_public_path__ + "static/media/how-it-works-bestelle.a4c9bf60.png";